export enum WeekDay {
  SU = 'SU',
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
}

export const ALL_WEEK_DAYS: WeekDay[] = Object.values(WeekDay);

export const WEEK_DAYS_ORDER: WeekDay[] = [
  WeekDay.MO,
  WeekDay.TU,
  WeekDay.WE,
  WeekDay.TH,
  WeekDay.FR,
  WeekDay.SA,
  WeekDay.SU,
];

export const WEEK_DAY_I18N_KEY: Record<WeekDay, string> = {
  [WeekDay.MO]: 'weekDays.mon',
  [WeekDay.TU]: 'weekDays.tue',
  [WeekDay.WE]: 'weekDays.wed',
  [WeekDay.TH]: 'weekDays.thu',
  [WeekDay.FR]: 'weekDays.fri',
  [WeekDay.SA]: 'weekDays.sat',
  [WeekDay.SU]: 'weekDays.sun',
};
